
  import {mapSectionComponents} from '@/helper/SectionHelper';
  import {getMetaTags} from '@/helper/Seo';
  import LazyHydrate from 'vue-lazy-hydration';
  import {createObjectFromQueryString} from '@/helper/QueryHelper';
  import {scopeHelper} from '@/helper/ScopeHelper';

  export default {
    name: 'OrganizationArticle',
    components: {
      LazyHydrate,
    },
    layout: 'organization',
    async asyncData({route, error, $cachedStrapi, app, store}) {
      // Query page from Strapi; strapi-change for findOne is required!
      const pagePromise = $cachedStrapi
        .findOne('pages', 'organization-articles-category-article')
        .catch((e) => {
          if (e.statusCode !== 404) {
            throw e;
          }
        });

      // Query Article from Strapi based on slug; strapi-change for findOne is required!
      const articlePromise = $cachedStrapi
        .findOne('articles', route.params.article)
        .catch((e) => {
          if (e.statusCode !== 404) {
            throw e;
          }
        });

      const [page, article] = await Promise.all([pagePromise, articlePromise]);

      if (
        !scopeHelper(page, process.env.SCOPE_ORGANIZATION) ||
        !article.article_category ||
        !scopeHelper(article, process.env.SCOPE_ORGANIZATION)
      ) {
        error({statusCode: 404, message: 'Article not found'});
        return;
      }

      let search_url = '';
      if (store.getters['breadcrumbs/hasArticleListingRoute']) {
        const lastArticleListingRoute =
          store.state.breadcrumbs.lastArticleListingRoute;
        const filterValues = createObjectFromQueryString(
          lastArticleListingRoute.substring(
            lastArticleListingRoute.indexOf('?') + 1,
            lastArticleListingRoute.lastIndexOf('#')
          )
        );

        search_url =
          app.localePath({
            name: 'organization-articles-category',
            params: {
              category: article.article_category.slug,
            },
          }) +
          '?search=' +
          filterValues.search +
          '&category[]=' +
          article.article_category.slug;
      }

      //console.log('search_url',store.state.breadcrumbs);

      const sections = await mapSectionComponents(
        page.sections,
        async function (section) {
          switch (section.component) {
            case 'SectionSmallHero':
              if (article.cover_image.length > 0) {
                section.image = article.cover_image[0];
              }
              break;
            case 'SectionArticleDetails':
              section.article = article;
              section.content_scope = process.env.SCOPE_ORGANIZATION;
              break;

            case 'SectionBreadcrumbs':
              section.breadcrumbs = [
                {
                  text: app.i18n.t('page.index'),
                  disabled: false,
                  to: app.localePath({
                    name: 'organization',
                  }),
                  nuxt: true,
                  exact: true,
                },
                {
                  text: app.i18n.t('page.articles'),
                  disabled: false,
                  to: app.localePath(
                    store.getters['breadcrumbs/hasArticleListingRoute']
                      ? store.state.breadcrumbs.lastArticleListingRoute.split(
                          '#'
                        )[0]
                      : {
                          name: 'organization-articles',
                        }
                  ),
                  nuxt: true,
                  exact: true,
                },
                {
                  text: article.article_category.title,
                  disabled: false,
                  to: store.getters['breadcrumbs/hasArticleListingRoute']
                    ? search_url.split('#')[0]
                    : app.localePath({
                        name: 'organization-articles-category',
                        params: {
                          category: article.article_category.slug,
                        },
                      }),
                  nuxt: true,
                  exact: true,
                },
                {
                  text: article.title,
                  disabled: true,
                  to: app.localePath({
                    name: 'organization-articles-category-article',
                    params: {
                      category: article.article_category.slug,
                      article: article.slug,
                    },
                  }),
                  nuxt: true,
                  exact: true,
                },
              ];
              break;

            case 'SectionSeoContent':
              if (
                article.seo_content_config &&
                article.seo_content_config.seo_contents &&
                article.seo_content_config.seo_contents[0]
              ) {
                section.seoContent = await $cachedStrapi.findOne(
                  'seo-contents',
                  article.seo_content_config.seo_contents[0].id
                );
              } else if (
                section.seo_content_config &&
                section.seo_content_config.seo_contents &&
                section.seo_content_config.seo_contents[0]
              ) {
                section.seoContent = await $cachedStrapi.findOne(
                  'seo-contents',
                  section.seo_content_config.seo_contents[0].id
                );
              }
              break;
          }
        }
      );

      // Meta-Data mit Werten vom Artikel
      const metaData =
        article && article.meta
          ? article.meta
          : page && page.meta
          ? page.meta
          : {};

      return {
        metaData,
        sections,
      };
    },
    data() {
      return {
        metaData: {},
        sections: [],
      };
    },
    head() {
      return {
        title: this.metaData.title,
        meta: getMetaTags(this.metaData),
      };
    },
  };
